/**
 * Query keys for Storefront Theme and Page Config
 */

export const storefrontThemeQueryKeys = {
  list: () => ['storefront-theme', 'list'] as const,
  detail: (name: string) => ['storefront-theme', 'detail', name] as const,
};

export const storefrontPageConfigQueryKeys = {
  list: () => ['storefront-page-config', 'list'] as const,
  detail: (name: string) => ['storefront-page-config', 'detail', name] as const,
};
